/**
 * @file main.tsx
 * @description SPA entry. Boots React, mounts the i18n provider, and renders
 *   the App component into #root. Locale and direction defaults are applied
 *   on first paint.
 * @module App
 * @security The SPA ships only static assets. Security-sensitive logic lives
 *   in the API. The CSP delivered by the Worker forbids inline scripts and
 *   external origins unless explicitly allowlisted.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import i18n from './i18n';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

createRoot(container).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>,
);
